export default __webpack_public_path__ + "static/media/code_jdxcx_jdalkhfw.9a737a19.png";